import { render, staticRenderFns } from "./CreateNationalEvent.vue?vue&type=template&id=01ab9524&"
import script from "./CreateNationalEvent.vue?vue&type=script&lang=ts&"
export * from "./CreateNationalEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports